/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const styles = (theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,

    // Page Elements
    root: {
        [theme.breakpoints.down(600)]: {
            padding: '0 16px',
        },
    },
    blockBody: {
        width: '100%',
        minHeight: '600px',
        [theme.breakpoints.down(600)]: {
            minHeight: '400px',
        },
    },
});

const StoryBlockSkeleton = ({ classes }) => (
    <div className={classes.root}>
        <div className={`${classes.blockBody} ${classes.block}`} />
    </div>
);
StoryBlockSkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(StoryBlockSkeleton);
